import { render } from "./Header.vue?vue&type=template&id=2fabde4c&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2fabde4c&lang=scss&scoped=true"
import "./Header.vue?vue&type=style&index=1&id=2fabde4c&lang=scss"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fabde4c"]])

export default __exports__